require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-what-are-key-steps-the-world-bank-must-take-to-make.json") })
        }
      }, "path---en-us-update-what-are-key-steps-the-world-bank-must-take-to-make");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-what-are-key-steps-the-world-bank-must-take-to-make!./.cache/json/en-us-update-what-are-key-steps-the-world-bank-must-take-to-make.json
// module id = 826
// module chunks = 231608221292675